import o from "./ghl-ui.es1251.js";
function u(f, e) {
  var n = e ? o(f.buffer) : f.buffer;
  return new f.constructor(n, f.byteOffset, f.length);
}
export {
  u as default
};
